import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import SearchBar from '@app/components/SearchBar'
import { ITeam } from '@app/models/Team'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'
import { Column } from 'react-virtualized'
import { actionCreators, ITeamsListState } from '../modules/teamsList'

interface IComponentRouterProps {
  id: string
}

type ConnectionsListProps = ITeamsListState &
  RouteComponentProps<IComponentRouterProps> &
  typeof actionCreators

export default class ConnectionsListPage extends React.PureComponent<
  ConnectionsListProps
> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ConnectionsListProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public render() {
    return (
      <DocumentTitle title='Admin - Teams'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>Teams</h3>
            <SearchBar
              onChange={this._onChangeFilter}
              placeholder='Looking for a certain team?'
              size='sm'
              value={this.props.filterText}
            />
          </div>
          <div className='mt-4'>
            <InfiniteScrollTable
              isLoading={this.props.isLoading}
              items={this.props.items}
              loadItems={this.props.loadTeams}
              noRowsRenderer={this._noRowsRenderer}
              onRowClicked={this._onRowClicked}
              totalItems={this.props.totalItems}
              ref={this.tableRef}
            >
              <Column
                cellDataGetter={({ rowData }) => {
                  const team = rowData as ITeam
                  return team.name
                }}
                dataKey='name'
                flexGrow={1}
                label='Name'
                width={200}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const team = rowData as ITeam
                  return team.description || '-'
                }}
                dataKey='description'
                flexGrow={1}
                label='Description'
                width={200}
              />
            </InfiniteScrollTable>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No teams</div>
  }

  private _onRowClicked(item: ITeam, index: number) {
    this.props.history.push(`/admin/team/${item.id}`)
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
